function getRandomSign() {
    return Math.random() >= 0.5 ? 1 : -1;
}
export function createInertia(opts) {
    const { magnitude, destX = 0, destY = 0, i = 0.7, k = 0.3 } = opts;
    let { currX, currY, xp, yp } = opts;
    if (currX === undefined) {
        currX = getRandomSign() * (Math.random() * magnitude + magnitude * 2);
    }
    if (currY === undefined) {
        currY = getRandomSign() * (Math.random() * magnitude + magnitude * 2);
    }
    if (xp === undefined) {
        xp = getRandomSign() * (Math.random() * magnitude + magnitude);
    }
    if (yp === undefined) {
        yp = getRandomSign() * (Math.random() * magnitude + magnitude);
    }
    return {
        destX,
        destY,
        currX,
        currY,
        i,
        k,
        xp,
        yp
    };
}
export function updateInertia(inertia) {
    const { destX, destY, currX, currY, xp, yp, k, i } = inertia;
    const distX = destX - currX;
    const distY = destY - currY;
    const newXp = xp * i + distX * k;
    const newYp = yp * i + distY * k;
    const newCurrX = currX + newXp;
    const newCurrY = currY + newYp;
    if (Math.abs(newCurrX - destX) < 1 && Math.abs(newCurrY - destY) < 1 && Math.abs(newXp) < 1 && Math.abs(newYp) < 1) {
        // done animating
        return {
            inertia: {
                destX,
                destY,
                currX: destX, // currX is now the same as destX
                currY: destY, // currY is now the same as destY
                i,
                k,
                xp: newXp,
                yp: newYp
            },
            isDone: true
        };
    }
    else {
        return {
            inertia: {
                destX,
                destY,
                currX: newCurrX,
                currY: newCurrY,
                i,
                k,
                xp: newXp,
                yp: newYp
            },
            isDone: false
        };
    }
}
